import Alpine from 'alpinejs';
import { CartService } from '../service/CartService';
import { AllProducts } from '../registry/ProductRegistry';
import { AlpineDataToast } from '../alpine-data/Toast';

(window as typeof window & { Alpine: typeof Alpine }).Alpine = Alpine;

document.addEventListener('alpine:init', () => {
  Alpine.data('productCategory', () => ({
    addToCart(id: string) {
      const cartService = new CartService();
      const prod = AllProducts.find(p => p.id === id)
      if (prod) {
        cartService.addToCart(prod);
        return prod
      }
    }
  }));

  AlpineDataToast();

});

Alpine.start();
